import { format, formatDistanceToNow } from 'date-fns';
import { it } from 'date-fns/locale';

export function formatDate(date: string | Date, fmt = 'd MMM yyyy'): string {
  return format(new Date(date), fmt, { locale: it });
}

export function formatDateTime(date: string | Date): string {
  return format(new Date(date), 'd MMM yyyy, HH:mm', { locale: it });
}

export function formatRelative(date: string | Date): string {
  return formatDistanceToNow(new Date(date), { addSuffix: true, locale: it });
}

export function formatCurrency(value: number | string | null | undefined): string {
  const n = Number(value ?? 0);
  return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(n);
}

export function formatPercent(value: number): string {
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
}

const EVENT_TYPE_LABELS: Record<string, string> = {
  MATRIMONIO: 'Matrimonio',
  BATTESIMO: 'Battesimo',
  COMUNIONE: 'Comunione',
  CRESIMA: 'Cresima',
  COMPLEANNO: 'Compleanno',
  RITRATTO: 'Ritratto',
  ALTRO: 'Altro',
};

export function formatEventType(type: string): string {
  return EVENT_TYPE_LABELS[type] ?? type;
}

const PAYMENT_METHOD_LABELS: Record<string, string> = {
  CONTANTI: 'Contanti',
  BONIFICO: 'Bonifico',
  CARTA: 'Carta',
  PAYPAL: 'PayPal',
  ALTRO: 'Altro',
};

export function formatPaymentMethod(method: string): string {
  return PAYMENT_METHOD_LABELS[method] ?? method;
}

const DELIVERABLE_TYPE_LABELS: Record<string, string> = {
  ALBUM: 'Album',
  FOTO_DIGITALI: 'Foto digitali',
  VIDEO: 'Video',
  STAMPE: 'Stampe',
  USB: 'USB',
  ALTRO: 'Altro',
};

export function formatDeliverableType(type: string): string {
  return DELIVERABLE_TYPE_LABELS[type] ?? type;
}

export function clientFullName(client: { firstName: string; lastName: string }): string {
  return `${client.firstName} ${client.lastName}`;
}

export function parseDecimal(v: string | number | null | undefined): number {
  if (v == null) return 0;
  const n = typeof v === 'number' ? v : parseFloat(v);
  return isNaN(n) ? 0 : n;
}
